export enum LanguageResource {
  ServiceProvider = 'ServiceProvider',
}
